import React from 'react'
import Scroll from 'react-scroll'
import _ from 'underscore'
import ReactScrollLink from '../General/ReactScollLink'
import TranslationTime from '../General/TranslationTime'
import ItemAttributes from '../PosterFormatItem/ItemAttributes'
import seperateAttributes from '../functions/seperateAttributes'
import { KINOTICKETS } from '../constants/paymentProvider'
import { MULTICINEMA } from '../constants/multiCinemaModes'

let Element = Scroll.Element


const ShowtimePerformanceItem = ({index, activeCinema, item, translation, scrollToPosition, hiddenAttributes, additionalScrollName, onClickItem, attributeStyling, activeFilters}) => {
    const { timeUtc, movieTitle, moviePk, attributes, posterAttribute, deeplinkURL, id, cinema, alternativeLinks } = item
    const cinemas = pmkinoFrontVars.apiData.cinemas.items
    const currentCinemaId = pmkinoFrontVars.cliData.currentCinemaId
    const currentCinema = cinemas[currentCinemaId]
    const activeCinemaIsMutlicinema = activeCinema ? cinemas[activeCinema].scope.type === MULTICINEMA ? true : false : false
    const {technologyAttributesWithIcons, technologyAttributesWithoutIcons} = seperateAttributes(attributes)
    const performanceCinema = cinemas[cinema]
    const currentAlternativeLink = alternativeLinks && alternativeLinks[cinema]

    let cinemaDataProvider
    if(currentCinema.scope.type === MULTICINEMA) {
        cinemaDataProvider = performanceCinema.scope.cinemaDataProvider
    } else {
        cinemaDataProvider = currentCinema.scope.cinemaDataProvider
    }

    if(activeFilters) {
        if(activeFilters.technical) {
            const hasAttribute = _.find(attributes, (attribute) => {
                return _.contains(activeFilters.technical, attribute.id)
            })

            if(!hasAttribute) {
                return ''
            }
        }
    }

    if(currentAlternativeLink) {
        return (
            <li className="showtime-performance">
                <a className="grid-showtimes-performance cursor-pointer" href={currentAlternativeLink} rel="noreferrer" target="_blank">
                    <div className="showtime-date text-large-bold">
                        <TranslationTime id="showtimePerformance" trans={translation} dateString={timeUtc} />
                    </div>
                    <div>
                        <div className="showtimes-performance-attributes">
                            <div className="grid-showtimes-attributes clearfix">
                                <ItemAttributes attributeStyling={attributeStyling} hiddenAttributes={hiddenAttributes} translation={translation} attributes={technologyAttributesWithoutIcons} canBeColored={true} />
                            </div>
                        </div>
                        <div className="showtimes-performance-title text-large-medium">{movieTitle}</div>
                        <div className="showtimes-performance-attributes">
                            <div className="grid-showtimes-attributes clearfix">
                                <ItemAttributes attributeStyling={attributeStyling} hiddenAttributes={hiddenAttributes} translation={translation} attributes={technologyAttributesWithIcons} canBeColored={true}/>
                            </div>
                        </div>
                        {posterAttribute && <div className="showtimes-poster-attribute text-medium">{posterAttribute.name}</div>}
                        {activeCinemaIsMutlicinema && <div className="showtimes-poster-attribute text-medium">{performanceCinema.nameDisplay}</div>}
                    </div>
                </a>
            </li>
        )
    } else if(cinemaDataProvider.type === KINOTICKETS) {
        return (
            <li className="showtime-performance">
                <a className="grid-showtimes-performance cursor-pointer" href={deeplinkURL} rel="noreferrer" target="_blank">
                    <div className="showtime-date text-large-bold">
                        <TranslationTime id="showtimePerformance" trans={translation} dateString={timeUtc} />
                    </div>
                    <div>
                        <div className="showtimes-performance-attributes">
                            <div className="grid-showtimes-attributes clearfix">
                                <ItemAttributes attributeStyling={attributeStyling} hiddenAttributes={hiddenAttributes} translation={translation} attributes={technologyAttributesWithoutIcons} canBeColored={true} />
                            </div>
                        </div>
                        <div className="showtimes-performance-title text-large-medium">{movieTitle}</div>
                        <div className="showtimes-performance-attributes">
                            <div className="grid-showtimes-attributes clearfix">
                                <ItemAttributes attributeStyling={attributeStyling} hiddenAttributes={hiddenAttributes} translation={translation} attributes={technologyAttributesWithIcons} canBeColored={true}/>
                            </div>
                        </div>
                        {posterAttribute && <div className="showtimes-poster-attribute text-medium">{posterAttribute.name}</div>}
                        {activeCinemaIsMutlicinema && <div className="showtimes-poster-attribute text-medium">{performanceCinema.nameDisplay}</div>}
                    </div>
                </a>
            </li>
        )
    } else {
        return (
            <li className="showtime-performance">
                <Element name={moviePk + '-' + timeUtc + additionalScrollName}></Element>

                <ReactScrollLink 
                    className={"grid-showtimes-performance cursor-pointer " + moviePk}
                    onClick={() => onClickItem({
                        id: id,
                        timeUtc: timeUtc,
                        url: deeplinkURL,
                        movieId: moviePk,
                        movieTitle: movieTitle,
                        cinema: cinema
                    })}
                    to={scrollToPosition + ' movieInformation'} 
                    smooth={true} 
                    offset={-100}
                >
                    <div className="showtime-date text-large-bold">
                        <TranslationTime id="showtimePerformance" trans={translation} dateString={timeUtc} />
                    </div>
                    <div>
                        <div className="showtimes-performance-attributes">
                            <div className="grid-showtimes-attributes clearfix">
                                <ItemAttributes attributeStyling={attributeStyling} hiddenAttributes={hiddenAttributes} translation={translation} attributes={technologyAttributesWithoutIcons} canBeColored={true} />
                            </div>
                        </div>
                        <div className="showtimes-performance-title text-large-medium">{movieTitle}</div>
                        <div className="showtimes-performance-attributes">
                            <div className="grid-showtimes-attributes clearfix">
                                <ItemAttributes attributeStyling={attributeStyling} hiddenAttributes={hiddenAttributes} translation={translation} attributes={technologyAttributesWithIcons} canBeColored={true}/>
                            </div>
                        </div>
                        {posterAttribute && <div className="showtimes-poster-attribute text-medium">{posterAttribute.name}</div>}
                        {activeCinemaIsMutlicinema && <div className="showtimes-poster-attribute text-medium">{performanceCinema.nameDisplay}</div>}
                    </div>
                </ReactScrollLink>
                <Element name={moviePk + additionalScrollName + ' openMovieInformation'}></Element>
            </li>
        )
    }
}

export default ShowtimePerformanceItem